// extracted by mini-css-extract-plugin
export var blink = "_6x-2";
export var cursor = "_6x-1";
export var reactMarkdown = "_6x-3";
export var streamingText = "_6x-0";